import { render, staticRenderFns } from "./ProjectAssignmentTabs.vue?vue&type=template&id=8a0f8e82"
import script from "./ProjectAssignmentTabs.vue?vue&type=script&lang=js"
export * from "./ProjectAssignmentTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports